import Component from '../colorz/Component';

import device from '../colorz/utils/device';
import Cookies from 'cookies-js';

module.exports = class Cookie extends Component {
  onInit( el, args) {
    // Initializations
    this.onClick = this.onClick.bind( this );

    this.el = el;
    this.btn = this.el.querySelector('.js-accept');
    this.close = this.el.querySelector('.js-close');
  }

  onReady() {
    if (Cookies.get('fp_cookie_accepted') != '1') {
      this.el.style.display = 'block';

      this.timeout = setTimeout( () => {
        this.el.classList.add('is-open');
      }, 300);
    }

    this.btn.addEventListener( device.pointerdown, this.onClick );
    this.close.addEventListener( device.pointerdown, this.onClick );
  }

  onClick() {
    if (Cookies.enabled) {
        Cookies.set('fp_cookie_accepted','1', { expires : 365, path: '/', secure: false });
        this.el.classList.add('is-close');

        this.timeout = setTimeout( () => {
          this.el.style.display = 'none';
        }, 300);
    }
  }
}